"use strict";
/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchGetSellerWebhooks = exports.GET_SELLER_WEBHOOKS_KEY = exports.fetchGetSellerPricing = exports.GET_SELLER_PRICING_KEY = exports.fetchPutSellerPayLink = exports.PUT_SELLER_PAY_LINK_KEY = exports.fetchPostSellerPayLink = exports.POST_SELLER_PAY_LINK_KEY = exports.fetchGetSellerPayLink = exports.GET_SELLER_PAY_LINK_KEY = exports.fetchGetBuyerSpendingLimit = exports.GET_BUYER_SPENDING_LIMIT_KEY = exports.LapiError = exports.fetchLendingAPIJSON = exports.fetchLendingAPI = void 0;
const lendingAPI_1 = require("./lendingAPI");
var lendingAPI_2 = require("./lendingAPI");
Object.defineProperty(exports, "fetchLendingAPI", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPI; } });
Object.defineProperty(exports, "fetchLendingAPIJSON", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPIJSON; } });
Object.defineProperty(exports, "LapiError", { enumerable: true, get: function () { return lendingAPI_2.LapiError; } });
exports.GET_BUYER_SPENDING_LIMIT_KEY = "getBuyerSpendingLimit";
/**
 * No description
 */
function fetchGetBuyerSpendingLimit({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/buyer/${stateKey}/spending_limit/`, {
        method: "get",
    });
}
exports.fetchGetBuyerSpendingLimit = fetchGetBuyerSpendingLimit;
exports.GET_SELLER_PAY_LINK_KEY = "getSellerPayLink";
/**
 * No description
 */
function fetchGetSellerPayLink({ stateKey, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/pay_link/`, {
        method: "get",
        query,
    });
}
exports.fetchGetSellerPayLink = fetchGetSellerPayLink;
exports.POST_SELLER_PAY_LINK_KEY = "postSellerPayLink";
/**
 * No description
 */
function fetchPostSellerPayLink({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/pay_link/`, {
        method: "post",
        body,
    });
}
exports.fetchPostSellerPayLink = fetchPostSellerPayLink;
exports.PUT_SELLER_PAY_LINK_KEY = "putSellerPayLink";
/**
 * No description
 */
function fetchPutSellerPayLink({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/pay_link/`, {
        method: "put",
        body,
    });
}
exports.fetchPutSellerPayLink = fetchPutSellerPayLink;
exports.GET_SELLER_PRICING_KEY = "getSellerPricing";
/**
 * No description
 */
function fetchGetSellerPricing({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/pricing/`, {
        method: "get",
    });
}
exports.fetchGetSellerPricing = fetchGetSellerPricing;
exports.GET_SELLER_WEBHOOKS_KEY = "getSellerWebhooks";
/**
 * No description
 */
function fetchGetSellerWebhooks({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/webhooks/`, {
        method: "get",
    });
}
exports.fetchGetSellerWebhooks = fetchGetSellerWebhooks;
